import { mergeTemplate } from './base-template';

export const finanzberatungTemplate = mergeTemplate({
  name: 'Finanzberatung',
  icon: '📈',
  settings: {
    primaryColor: '#0f172a',
    accentColor: '#0ea5e9',
    fontStack: 'instrument',
    stylePreset: 'swiss',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Finanzberatung & Vermögensverwaltung',
      heroSubtitle: 'Unabhängige Beratung für Ihre finanziellen Ziele',
      packages: [
        { name: 'Finanzanalyse', price: 'ab CHF 500', description: 'Umfassende Bestandsaufnahme Ihrer Finanzen', features: 'Vermögensübersicht, Risikoanalyse, Vorsorge-Check, Handlungsempfehlungen', highlighted: false },
        { name: 'Strategie & Planung', price: "ab CHF 2'000", description: 'Individuelle Finanzstrategie', features: 'Anlagekonzept, Steueroptimierung, Vorsorgeplanung, Erbschaftsplanung', highlighted: true },
        { name: 'Vermögensverwaltung', price: '0.5-1.0% p.a.', description: 'Aktive Betreuung Ihres Portfolios', features: 'Portfoliomanagement, Reporting, Rebalancing, Steueroptimierung, laufende Beratung', highlighted: false },
      ],
      ctaTitle: 'Ihre Finanzen verdienen einen Plan',
      ctaText: 'Vereinbaren Sie ein kostenloses Erstgespräch — unverbindlich und vertraulich.',
      ctaButtonText: 'Erstgespräch buchen',
    },
    pageMethoden: {
      heroTitle: 'Unser Beratungsprozess',
      heroSubtitle: 'Systematisch, unabhängig, transparent',
      introText: 'Gute Finanzberatung beginnt mit Zuhören. Wir analysieren Ihre Situation, bevor wir Empfehlungen aussprechen.',
      steps: [
        { title: 'Bestandsaufnahme', description: 'Vollständige Erfassung Ihrer Vermögens- und Einkommenssituation' },
        { title: 'Zieldefinition', description: 'Gemeinsame Definition Ihrer kurz- und langfristigen Finanzziele' },
        { title: 'Strategieentwicklung', description: 'Individuelles Anlage- und Vorsorgekonzept' },
        { title: 'Umsetzung & Review', description: 'Implementierung, laufendes Monitoring und jährliche Anpassung' },
      ],
      tools: [
        { name: 'Unabhängige Analyse', description: 'Keine Bindung an einzelne Produktanbieter' },
        { name: 'Finanzplanungs-Software', description: 'Professionelle Simulation und Szenarioanalyse' },
        { name: 'Reporting-Portal', description: 'Online-Zugang zu Ihrem Portfolio und Berichten' },
      ],
      philosophyTitle: 'Beratungsphilosophie',
      philosophyText: 'Unabhängigkeit, Transparenz und langfristiges Denken — das sind die Grundpfeiler unserer Beratung.',
    },
    pageUeberMich: {
      heroTitle: 'Über uns',
      heroSubtitle: 'Erfahrung und Vertrauen seit über 15 Jahren',
      introText: 'Als unabhängige Finanzberater sind wir ausschliesslich unseren Kunden verpflichtet — nicht Produktanbietern.',
      timeline: [
        { year: '2007', text: 'Gründung der Finanzberatung' },
        { year: '2014', text: 'Erweiterung um Vermögensverwaltung' },
        { year: '2021', text: 'Digitalisierung des Kundenportals' },
      ],
      values: [
        { title: 'Unabhängigkeit', description: 'Keine Provisionen, keine versteckten Interessen' },
        { title: 'Transparenz', description: 'Alle Kosten und Honorare offen kommuniziert' },
        { title: 'Langfristigkeit', description: 'Beziehungen über Generationen, nicht Quartale' },
      ],
      certifications: 'IAF, CFP, FINMA-registriert',
    },
  },
  components: {
    header: {
      companyName: 'Finanzen Muster',
      logoText: 'FM',
      navItems: ['Leistungen', 'Methodik', 'Team', 'Kontakt'],
      ctaText: 'Erstgespräch',
    },
    hero: {
      title: 'Klarheit. Strategie. Umsetzung.',
      subtitle:
        'Unabhängige Finanzberatung für nachhaltigen Vermögensaufbau.',
      primaryBtn: 'Erstgespräch vereinbaren',
      secondaryBtn: 'Philosophie',
    },
    trust: {
      items: [
        { value: 'Unabhängig', label: 'Beratung' },
        { value: 'Transparent', label: 'Kosten' },
        { value: 'Langfristig', label: 'Strategie' },
        { value: 'FINMA', label: 'Reguliert' },
      ],
    },
    authority: {
      title: 'Qualität & Standards',
      variant: 'badges',
      items: [
        {
          icon: '🎓',
          text: 'Zertifizierte Finanzplaner (CFP, CFA oder gleichwertig)',
        },
        { icon: '🛡️', text: 'Unabhängig – keine Produktbindung' },
        { icon: '📊', text: 'Evidenzbasierte Anlagestrategien' },
      ],
    },
    services: {
      title: 'Beratungsfelder',
      subtitle: 'Ganzheitliche Finanzplanung.',
      items: [
        {
          icon: '🎯',
          title: 'Finanzplanung',
          text: 'Lebensphasengerechte Strategie mit klaren Zielen.',
        },
        {
          icon: '📊',
          title: 'Anlageberatung',
          text: 'Evidenzbasiert, kosteneffizient, risikoadjustiert.',
        },
        {
          icon: '🏦',
          title: 'Vorsorge',
          text: '3a, Pensionskasse, Nachfolge – strukturiert geplant.',
        },
      ],
    },
    benefits: {
      title: 'Warum unabhängig?',
      subtitle: '',
      items: [
        {
          title: 'Keine Interessenkonflikte',
          text: 'Wir verdienen nicht an Produkten, sondern an Ihrer Zufriedenheit.',
        },
        {
          title: 'Transparente Kosten',
          text: 'Klare Honorarstruktur ohne versteckte Gebühren.',
        },
        {
          title: 'Langfristige Beziehung',
          text: 'Wir begleiten Sie durch alle Lebensphasen.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Erfahrene Finanzplaner an Ihrer Seite.',
      members: [
        {
          name: 'Daniel Frei',
          role: 'Inhaber & Finanzplaner CFP',
          image: '',
          bio: 'Vermögensverwaltung, Vorsorgeplanung, Anlageberatung. Über 15 Jahre Erfahrung.',
        },
        {
          name: 'Sabine Leuenberger',
          role: 'Steuerberaterin & Finanzplanerin',
          image: '',
          bio: 'Steueroptimierung, Nachfolgeplanung, Pensionskassenberatung.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote:
            'Endlich verstehe ich meine Finanzen — und habe einen klaren Plan.',
          author: 'Martin Kägi',
          role: 'Unternehmer, Winterthur',
        },
        {
          quote: 'Die Vorsorgeplanung hat mir echte Klarheit gebracht. Sehr kompetente und ehrliche Beratung.',
          author: 'Claudia Bosshard',
          role: 'Ärztin, Zürich',
        },
        {
          quote: 'Dank der unabhängigen Analyse konnte ich meine Anlagekosten deutlich senken.',
          author: 'Peter Zürcher',
          role: 'Pensionierter Ingenieur',
        },
        {
          quote: 'Professionell, transparent und immer erreichbar. Genau so stelle ich mir Finanzberatung vor.',
          author: 'Nicole & Reto Steiner',
          role: 'Ehepaar, Familienplanung',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Was kostet ein Erstgespräch?',
          answer:
            'Das Erstgespräch ist unverbindlich und kostenlos. Danach erhalten Sie eine klare Offerte mit transparenter Honorarstruktur.',
        },
        {
          question: 'Sind Sie wirklich unabhängig?',
          answer:
            'Ja. Wir erhalten keine Provisionen oder Retrozessionen von Produktanbietern. Unser Honorar zahlen Sie direkt — so sind wir ausschliesslich Ihnen verpflichtet.',
        },
        {
          question: 'Ab welchem Vermögen lohnt sich eine Beratung?',
          answer:
            'Eine Finanzplanung lohnt sich ab einem Vermögen von ca. CHF 100\'000 oder bei komplexeren Situationen wie Immobilienkauf, Firmengründung oder Pensionierung.',
        },
        {
          question: 'Wie oft sollte man die Finanzplanung überprüfen?',
          answer:
            'Wir empfehlen ein jährliches Review. Bei grösseren Veränderungen wie Heirat, Immobilienkauf oder Jobwechsel beraten wir Sie gerne auch kurzfristig.',
        },
      ],
    },
    cta: {
      title: 'Erstgespräch vereinbaren',
      subtitle:
        'Unverbindlich und kostenfrei – wir hören zu und geben erste Einschätzungen.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    footer: {
      companyName: 'Finanzen Muster',
      tagline: 'Unabhängige Finanzberatung.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
  },
});
